import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'

import { ModalDialogProps } from './ModalDialog.types'
import Icon from '../Icon'
import Flex from '../Flex'
import Box from '../Box'

const Dialog: React.FC<ModalDialogProps> = ({
  isVisible,
  onClose,
  verticalCentered,
  children,
  closable,
  padding,
  width = 'fit-content',
  height = 'fit-content',
  ...restProps
}) => {
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflowY = 'hidden'
      return
    }
    document.body.style.removeProperty('overflow-y')
  }, [isVisible])

  if (!isVisible) return null

  return createPortal(
    <Flex
      zIndex={1000}
      width='100vw'
      height='100vh'
      position='fixed'
      backgroundColor='overlay75'
      justifyContent='center'
      alignItems={verticalCentered ? 'center' : 'flex-start'}
      paddingTop={!verticalCentered && '16px'}
      onClick={closable && onClose}
      top={0}
      left={0}
    >
      <Flex
        backgroundColor='white'
        padding={padding || '40px'}
        borderRadius='16px'
        justifyContent='flex-start'
        alignItems='flex-start'
        aria-label='modal-dialog-content'
        onClick={(event: React.MouseEvent<HTMLElement>) => event.stopPropagation()}
      >
        <Flex position='relative' width={width} height={height} {...restProps}>
          {closable && (
            <Box position='absolute' top='0' right='0'>
              <Icon
                name='Close-outline'
                aria-label='modal-dialog-close-button'
                onClick={onClose}
                cursor='pointer'
                color='black60'
              />
            </Box>
          )}
          {children}
        </Flex>
      </Flex>
    </Flex>,
    document.body,
  )
}

export default Dialog
